import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { gr } from "../tokens";

// Short facts as label → value rows (a programme's length, start, end…): label grey on the left,
// value on the right, hairline between rows. Rendered as a <dl>.
export default function GrKeyValueList({ items, sx }) {
  return (
    <Box component="dl" sx={{ m: 0, ...sx }}>
      {items
        .filter((item) => item && item.label)
        .map((item) => (
          <Box
            key={item.key || String(item.label)}
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between",
              gap: gr.space[4],
              py: gr.space[3],
              fontFamily: gr.font.family,
              "&:first-of-type": { pt: 0 },
              "&:last-of-type": { pb: 0 },
              "& + &": { borderTop: `1px solid ${gr.color.line2}` },
            }}
          >
            <Box component="dt" sx={{ fontSize: gr.font.size.sm, color: gr.color.muted }}>
              {item.label}
            </Box>
            <Box
              component="dd"
              sx={{
                m: 0,
                fontSize: gr.font.size.md,
                fontWeight: gr.font.weight.medium,
                color: gr.color.ink,
                textAlign: "right",
                overflowWrap: "anywhere",
              }}
            >
              {item.value}
            </Box>
          </Box>
        ))}
    </Box>
  );
}

GrKeyValueList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node,
      value: PropTypes.node,
    })
  ).isRequired,
  sx: PropTypes.object,
};
